import { render, staticRenderFns } from "./BowCTABlockSx.vue?vue&type=template&id=73f2259f&"
import script from "./BowCTABlockSx.vue?vue&type=script&lang=js&"
export * from "./BowCTABlockSx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowCTABlock: require('/workspace/components/organisms/BowCTABlock/BowCTABlock.vue').default})
